<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
        >在线文档</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"> </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import onlineDoc from '../components/onlineDoc'

import { OPEN_API_TEST, OPEN_API_PRO } from '@/constants/index'
const apiUrlTest = 'tempCarTender/tenderOfferPrice'
export default {
  components: { onlineDoc },
  computed: {
    ...mapGetters(['token', 'uuid']),
    address() {
      return this.uuid.length > 0 ? `?uuid=${this.uuid}` : ''
    }
  },
  data() {
    return {
      mainStatus: 'online',
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: '与平台签约的客户，可通过此接口接收干线加班车招采的订单',
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: 'Headers',
            value: [
              {
                name: 'apiAccount',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '接入方在平台的api账户标识'
              },
              {
                name: 'digest',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '签名字符串'
              },
              {
                name: 'timestamp',
                type: 'Number',
                require: 'Y',
                normal: '',
                describe: '时间戳，毫秒'
              }
            ]
          },
          {
            title: '请求参数',
            value: [
              {
                name: 'bizContent',
                type: 'String',
                require: 'Y',
                normal: '业务参数',
                describe: '业务参数模块内json格式的string类型'
              }
            ]
          },
          {
            title: '业务参数',
            value: [
              {
                name: 'offerPrice',
                type: 'Number(11)',
                require: 'N',
                normal: '',
                describe: '报价价格【弃标非必填】'
              },
              {
                name: 'tenderNo',
                type: 'String(30)',
                require: 'Y',
                normal: '',
                describe: '需求编码'
              },
              {
                name: 'carrierContact',
                type: 'String(20)',
                require: 'N',
                normal: '',
                describe: '报价联系人限定20字【弃标非必填】'
              },
              {
                name: 'carrierContactPhone',
                type: 'String(30)',
                require: 'N',
                normal: '',
                describe: '报价联系人手机号限定11位【弃标非必填】'
              },
              {
                name: 'giveUpBid',
                type: 'Integer(2)',
                require: 'Y',
                normal: '',
                describe: '投标状态: 1-投标 2-弃标'
              },
              {
                name: 'remarks',
                type: 'String(200)',
                require: 'N',
                normal: '',
                describe: '弃标备注'
              },
              {
                name: 'userName',
                type: 'String(20)',
                require: 'N',
                normal: '2',
                describe: '报价人或弃标人'
              }
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: '响应参数',
            value: [
              {
                name: 'code',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '返回码，见附录'
              },
              {
                name: 'msg',
                type: 'String',
                require: 'Y',
                normal: '',
                describe: '描述'
              }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"offerPrice":120,"tenderNo":"XQBM202408270006","carrierContact":"y","carrierContactPhone":"17512341234","giveUpBid":1,"remarks":"","userName":"张三"}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success"
}
`),

        //错误代码提示
        errcodeJson: [
          { code: '100001', msg: '承运商身份验证失败' },
          { code: '100002', msg: '投标价格不能为空' },
          { code: '100003', msg: '标的信息不存在' },
          { code: '100004', msg: '承运商和项目不能为空' },
          { code: '100005', msg: '报价或弃标进行中，请稍后再试;' },
          { code: '100006', msg: '价格不允许为空' },
          { code: '100007', msg: '报价仅支持输入10的整数倍' },
          { code: '100008', msg: '当前项目限价%s元，请修改后再提交;' },
          { code: '100009', msg: '无相关合同信息' },
          {
            code: '1000010',
            msg: '报价日期超过合同日期范围内，请补充合同等信息'
          },
          {
            code: '1000011',
            msg: '报价日期超过营业执照信息日期范围内，请补充营业执照等信息'
          },
          { code: '1000012', msg: '无货物险信息' },
          {
            code: '1000013',
            msg: '报价日期超过货物险日期范围内，请补充货物险等信息'
          },
          { code: '1000014', msg: '无道路运输证信息' },
          {
            code: '1000015',
            msg: '报价日期超过道路运输证日期范围内，请补充道路运输证等信息'
          },
          { code: '1000016', msg: '当前已经超过报价次数无法报价;' },
          { code: '1000017', msg: '已弃标，无需再次弃标;' },
          { code: '1000018', msg: '未知账号;' },
          { code: '1000019', msg: '无权限报价/弃标;' },
          { code: '1000020', msg: '数据不存在' },
          { code: '1000021', msg: '项目状态：招标中，才允许报价或弃标;' },
          {
            code: '1000022',
            msg: '承运商不存在或承运商报价次数未设置，不允许报价或弃标;'
          },
          { code: '1000023', msg: '报价/弃标失败;' },
          { code: '1000024', msg: '无营业执照信息' },
          { code: '1000025', msg: '请先选择数据' }
        ]
      },

      apiTestData: {
        _headerData: {
          apiAccount: '1001',
          digest: 'U40e5sumorgd3YgZzU61Mw==',
          timestamp: '1565238848921'
        },
        data: {
          bizContent: `{"offerPrice":120,"tenderNo":"XQBM202408270006","carrierContact":"y","carrierContactPhone":"17512341234","giveUpBid":1,"remarks":"","userName":"张三"}`
        },
        //必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: '',
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [
          { code: '100001', msg: '承运商身份验证失败' },
          { code: '100002', msg: '投标价格不能为空' },
          { code: '100003', msg: '标的信息不存在' },
          { code: '100004', msg: '承运商和项目不能为空' },
          { code: '100005', msg: '报价或弃标进行中，请稍后再试;' },
          { code: '100006', msg: '价格不允许为空' },
          { code: '100007', msg: '报价仅支持输入10的整数倍' },
          { code: '100008', msg: '当前项目限价%s元，请修改后再提交;' },
          { code: '100009', msg: '无相关合同信息' },
          {
            code: '1000010',
            msg: '报价日期超过合同日期范围内，请补充合同等信息'
          },
          {
            code: '1000011',
            msg: '报价日期超过营业执照信息日期范围内，请补充营业执照等信息'
          },
          { code: '1000012', msg: '无货物险信息' },
          {
            code: '1000013',
            msg: '报价日期超过货物险日期范围内，请补充货物险等信息'
          },
          { code: '1000014', msg: '无道路运输证信息' },
          {
            code: '1000015',
            msg: '报价日期超过道路运输证日期范围内，请补充道路运输证等信息'
          },
          { code: '1000016', msg: '当前已经超过报价次数无法报价;' },
          { code: '1000017', msg: '已弃标，无需再次弃标;' },
          { code: '1000018', msg: '未知账号;' },
          { code: '1000019', msg: '无权限报价/弃标;' },
          { code: '1000020', msg: '数据不存在' },
          { code: '1000021', msg: '项目状态：招标中，才允许报价或弃标;' },
          {
            code: '1000022',
            msg: '承运商不存在或承运商报价次数未设置，不允许报价或弃标;'
          },
          { code: '1000023', msg: '报价/弃标失败;' },
          { code: '1000024', msg: '无营业执照信息' },
          { code: '1000025', msg: '请先选择数据' }
        ]
      }
    }
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>
